import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectHidingPhoneNumberRegions = (state: IState) => featureToggleSelector(state).hidingPhoneNumberRegions;
